<template>
  <div class="d-flex flex-column ga-8">
    <div class="d-flex flex-column ga-4">
      <h2 class="title-medium">Comunicações</h2>

      <div class="lgpd-box d-flex flex-column ga-4">
        <rb-select
          v-model="localData.selectedCrmSignatureIds"
          :items="localData.crmSignatureOptions"
          item-title="title"
          item-value="id"
          label="Tipos de assinaturas"
          persistent-hint
          multiple
          chips
          closable-chips
          clearable
          inline
        />
      </div>
    </div>

    <div class="d-flex flex-column ga-4">
      <h2 class="title-medium">Consentimento de privacidade</h2>

      <div class="lgpd-box d-flex flex-column ga-4">
        <RbRichTextEditor
          v-model="localData.legalBasisConfig.privacyText"
          label="Texto de privacidade"
          required
        />

        <RbRichTextEditor
          v-model="localData.legalBasisConfig.acceptanceText"
          label="Texto de consentimento para processar"
          required
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import RbRichTextEditor from '@/ai_studio/components/common/RbRichTextEditor.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  inputRules: {
    type: Object,
    required: true
  }
});

const localData = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue);
  }
});
</script>

<style lang='scss' scoped>
.lgpd-box {
  border: 1px solid rgb(var(--v-theme-neutral-80));
  border-radius: 8px;
  padding: 16px;
}
</style>
